import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const RoleRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        let user = JSON.parse(localStorage.getItem('user'));
        var showVote = user && user.roles && user.roles.indexOf('judge') > -1;
        var showResults = user && user.roles && user.roles.indexOf('admin') > -1;

        if (showVote)
            return (<Redirect to={{ pathname: '/vote', state: { from: props.location } }} />);

        if (showResults)
            return (<Redirect to={{ pathname: '/results', state: { from: props.location } }} />);

        return (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />);

    }
} />
)